var React = require('react');
const costMappings = JSON.parse(document.getElementById('cost-mappings').getAttribute('data_value'));
import optionNames from '../NameMappings'

class QuantityErrorMessage extends React.Component {

    constructor() {
        super();
    }

    quantityLeft(type) {
        return (this.props.store.brewery.capacities[type] || {}).quantity_left || 0;
    }

    quantity(type) {
        return (this.props.store.brewery.capacities[type] || {}).quantity || 0;
    }

    get overUsedArray(){
        return ['production_suite', 'bacterial_analysis', 'yeast_analysis', 'alcolyzer_selzer'].filter((prop)=>{
            if(this.quantity(prop) === 0) { // return false, user does not have subsc. for prop
                return false
            } else {
                const remaining =  this.quantityLeft(prop) - (this.props.store.checkCount || {})[prop]
                return remaining < 0 //exceeds usage
            }
        })
    }

    get overused(){
        return this.overUsedArray.map((o)=>{
                return optionNames[o]
            })
            .join(', ')
    }

    render() {
        return (
            <div className="row margin-top-sm">
                {
                    this.overUsedArray.length > 0 &&
                    <div className={'w100'}>
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-right">
                            <div className={'subscription-error'}>
                                You have exceeded your subscription for: <b>{this.overused}</b>
                                <input hidden name={'order_error_message'} value={`Exceeded allowance for: ${this.overused}`} />
                            </div>
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                }
            </div>
        );
    }
}

export default QuantityErrorMessage